import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import { Socket } from "../../../../infrastructure/socket.service";
import { UI } from "../../../../services/ui.service";
import { UploadService } from "../../../../infrastructure/upload/upload-service";
import { IBroadcastsRepository } from "../../../../domain/broadcasts/i-broadcasts-repository";
import { BroadcastPreset } from "../../../../domain/broadcasts/broadcast-preset";
import { Subscription } from "rxjs";
import { Block } from "../../../../domain/blocks/block";

@Component({
  selector: "evrideo-broadcast-library-item",
  templateUrl: "./broadcast-library-item.component.html",
  styleUrls: ["./broadcast-library-item.component.scss"],
})
export class BroadcastLibraryItemComponent implements OnInit {
  @Input()
  item: BroadcastPreset;

  @Input()
  viewMode = "gallery";

  menuOpen = false;
  dragged = false;

  @Output()
  onDelete = new EventEmitter();
  broadcastUpdatedSubscription: Subscription;

  constructor(
    private ref: ElementRef,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private socketService: Socket,
    private ui: UI,
    private uploadService: UploadService,
    private _broadcastPresetsRepository: IBroadcastsRepository,
  ) {}

  ngOnInit() {
    this.ref.nativeElement.addEventListener(
      "dragstart",
      this.onDragStart.bind(this),
      false,
    );
    this.ref.nativeElement.addEventListener(
      "dragend",
      this.onDragEnd.bind(this),
      false,
    );

    this.broadcastUpdatedSubscription =
      this._broadcastPresetsRepository.updated.subscribe(
        this.onBroadcastUpdated.bind(this),
      );
  }
  onBroadcastUpdated(broadcastPreset: BroadcastPreset) {
    if (this.item.id === broadcastPreset.id) {
      this.item = broadcastPreset;
      this.changeDetectorRef.markForCheck();
    }
  }

  delete() {
    this.ui.notify(this.ui.EVENTS.ShowConfirm, {
      title: "Delete broadcast preset",
      message: "Are you sure about that?",
      buttons: [
        {
          title: "Yes",
          callback: this.onDeleteConfirmed.bind(this),
        },
        {
          title: "No",
          callback: this.onDeleteCancelled.bind(this),
        },
      ],
    });
  }

  onDeleteConfirmed() {
    this.onDelete.emit();
  }

  onDeleteCancelled() {}

  edit() {
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate(["/broadcasts/edit/", this.item.id]);
    });
  }

  onDragStart(event: DragEvent) {
    this.dragged = true;
    event.dataTransfer.setData("text/broadcast", JSON.stringify(this.item));
    event.dataTransfer.dropEffect = "copy";
  }

  onDragEnd(event) {
    this.dragged = false;
  }

  onUploadThumbnail(event) {
    if (!event.target.files.length) {
      return;
    }
    let url: string;
    this.uploadService
      .uploadSmallFile(event.target.files[0])
      .then((result) => {
        url = result;
        this.item.thumbnailUrl = url;
        return this._broadcastPresetsRepository.update(this.item);
      })
      .then(() => {
        this.changeDetectorRef.markForCheck();
      });
    event.target.value = "";
  }
}
